<template>
  <v-snackbar
    v-model="snackData.status"
    :color="styleSnackbarContent.background"
    :timeout="4500"
  >
    <section
      class="snackbar__layout"
      :data-cy="`snackbar-${styleSnackbarContent.type}`"
    >
      <v-icon
        class="background-icon"
        :class="snackData.type"
        size="24"
        color="#FFFFFF"
      >
        {{ styleSnackbarContent.icon }}
      </v-icon>

      <div>
        <h4>{{ snackData.title }}</h4>
        <span>{{ snackData.description }}</span>
      </div>
    </section>

    <template v-slot:action="{ attrs }">
      <v-btn
        color="#181818"
        text
        icon
        v-bind="attrs"
        @click="snackData.status = false"
      >
        <v-icon text>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "snackbarAlert",

  computed: {
    snackData() {
      return this.$snackbar.getData();
    },

    styleSnackbarContent() {
      switch (this.snackData.type) {
        case "success":
          return {
            type: "success",
            background: "snackbar__background-success",
            icon: "mdi-checkbox-marked-circle-outline",
          };

        case "error":
          return {
            type: "error",
            background: "snackbar__background-error",
            icon: "mdi-alert-circle-outline",
          };

        case "message":
          return {
            type: "message",
            background: "snackbar__background-message",
            icon: "mdi-message-badge-outline",
          };

        case "warning":
          return {
            type: "warning",
            background: "snackbar__background-warning",
            icon: "mdi-alert-rhombus-outline",
          };

        default:
          return { background: "", icon: "" };
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";

.v-sheet.v-snack__wrapper:not(.v-sheet--outlined) {
  box-shadow: rgba(126, 126, 126, 0.1) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px !important;
}

.v-snack__wrapper {
  border-radius: 15px !important;
}

.snackbar__background-success {
  background: $light-green !important;
}

.snackbar__background-error {
  background: $light-red !important;
}

.snackbar__background-message {
  background: $light-blue !important;
}

.snackbar__background-warning {
  background: $light-orange !important;
}

.snackbar__layout {
  display: flex !important;
  align-items: center;
  gap: 12px;
  color: $medium-dark;

  .background-icon {
    padding: 8px;
    border-radius: 50%;
    width: fit-content;
    height: fit-content;
  }

  .message {
    background: $blue;
  }
}
</style>
